import { BaseButton } from './'

export function Button({ children, ...rest }) {
    return (
        <BaseButton TagName="button" {...rest}>
            {children}
        </BaseButton>
    )
}
